import React from 'react';

export default function SuggestionBox({ suggestions = [], onSelect = () => {} }) {
  if (!suggestions || suggestions.length === 0) return null;
  return (
    <div className="suggestion-box" role="listbox">
      {suggestions.map((s, i) => (
        <div key={i} className="suggestion-item" onMouseDown={(e) => e.preventDefault()} onClick={() => onSelect(s)}>
          <span className="suggestion-icon">💡</span>
          <span className="suggestion-text">{s}</span>
        </div>
      ))}
    </div>
  );
}